import { environment } from '@environment';

export function prepareApp(): Promise<void> {
  return new Promise((resolve) => {
    if (environment.mockServiceWorker.enabled) {
      import('./browser').then(({ worker }) => {
        worker
          .start({
            serviceWorker: {
              url: `${environment.mockServiceWorker.baseUrl}/spa/mockServiceWorker.js`.toLocaleLowerCase(),
              options: {
                scope: `${environment.baseUrl}/`.toLocaleLowerCase(),
              },
            },
          })
          .then(() => {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({
                environment,
              });
            }
            resolve();
          });
      });
    } else {
      resolve();
    }
  });
}
